import { Injectable } from '@angular/core';
import {Observable} from 'rxjs';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {environment, isODM} from '../../environments/environment';


@Injectable({
  providedIn: 'root'
})
export class MailService {
  constructor(private http: HttpClient) { }

  ReadMailModule(params): Observable <any> {
    return this.http.post<any>(`${environment.apiIotUrl}/mail/module/read`, params);
  }

  AddMailModule(params): Observable<any> {
    return this.http.post<any>(`${environment.apiIotUrl}/mail/module/add`, params);
  }

  UpdateMailModule(params): Observable<any> {
    return this.http.post<any>(`${environment.apiIotUrl}/mail/module/update`, params);
  }

  DeleteMailModule(params): Observable<any> {
    return this.http.post<any>(`${environment.apiIotUrl}/mail/module/delete`, params);
  }

  ReadMailGroup(params): Observable <any> {
    return this.http.post<any>(`${environment.apiIotUrl}/mail/group/read`, params);
  }

  AddMailGroup(params): Observable<any> {
    return this.http.post<any>(`${environment.apiIotUrl}/mail/group/add`, params);
  }

  UpdateMailGroup(params): Observable<any> {
    return this.http.post<any>(`${environment.apiIotUrl}/mail/group/update`, params);
  }

  DeleteMailGroup(params): Observable<any> {
    return this.http.post<any>(`${environment.apiIotUrl}/mail/group/delete`, params);
  }
}
